import React, { useMemo, useState } from 'react';
import useCheckIsMobile from 'Shared/hooks/useCheckIsMobile';

import { Link } from 'react-router-dom';
import ActionMenu from '../../../../../screens/Projects/components/ActionMenu/ActionMenu';

import FormMenuBtnSvg from 'Components/Admin/assets/FormMenuBtnSVG';
import MoreSVG from 'Components/Admin/assets/MoreSVG';
import Navbar from 'Components/Admin/Form/components/Navbar/Navbar';
import DropdownMenu from 'Components/Admin/DropdownMenu';

const FormLayout = ({ routes, children, menuItems = [], updateMenuItems = [] }) => {
  const isMobile = useCheckIsMobile();
  const [isOpenMobileNavbar, setIsOpenMobileNavbar] = useState(false);

  const openMobileNavbar = () => setIsOpenMobileNavbar(true);
  const closeMobileNavbar = () => setIsOpenMobileNavbar(false);

  const mobileToolBar = useMemo(() => (
    <>
      <div className="tool-bar__icon-container">
        <div className="tool-bar__icon" onClick={openMobileNavbar}>
          <FormMenuBtnSvg />
        </div>
      </div>
      <div className="tool-bar__icon-container">
        {
          Array.isArray(menuItems[0]) && menuItems[0].map(({ icon, title }) => (
            <div key={title} className="tool-bar__icon">{icon}</div>
          ))
        }
        <div className="tool-bar__icon">
          <DropdownMenu
            triggerButtonRender={() => <MoreSVG />}
            dropdownClassName="tool-bar__dropdown"
          >
            <ActionMenu menuItems={[...menuItems.slice(1), ...updateMenuItems]} />
          </DropdownMenu>
        </div>
      </div>
      {isOpenMobileNavbar && <Navbar routes={routes} onClose={closeMobileNavbar} />}
    </>
  ), [isOpenMobileNavbar, menuItems, updateMenuItems]);

  const sideBar = useMemo(() => (
    (
      <>
        <div>
          <Navbar routes={routes} />
          <ActionMenu title="Generation" menuItems={menuItems} className="form-layout__block" />
        </div>
        <div className="form-layout__block_links">
          {
            updateMenuItems.flat().map(({ title, path }) => (
              <Link key={path} to={path}>{title}</Link>
            ))
          }
        </div>
      </>
    )
  ), [menuItems]);

  return (
    <div className="form-layout">
      <div className="form-layout__side-bar">
        {isMobile ? mobileToolBar : sideBar}
      </div>
      <div className="form-layout__content">{children}</div>
    </div>
  );
};

export default FormLayout;
